/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable-next-line react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { useFormikContext } from 'formik';

import { Ionicons } from '@expo/vector-icons';
import Colors from '@global/colors';
import SociollaText from '@components/sociolla/SociollaText';
import FormError from '@components/form/common/FormError';
import PropTypes from 'prop-types';

const propTypes = {
  testID: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
    PropTypes.number,
    PropTypes.bool,
  ]),
  labelKey: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  isMultiple: PropTypes.bool,
  isWhite: PropTypes.bool,
  children: PropTypes.node,
  options: PropTypes.array,
  totalColumn: PropTypes.number,
  checkboxStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  checkboxCheckedStyle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  checkboxContainerStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),
  isManualError: PropTypes.bool,
  onChange: PropTypes.func,
  isManualContext: PropTypes.bool,
};

const defaultProps = {
  testID: 'checkbox',
  value: [],
  labelKey: '',
  checked: false,
  disabled: false,
  isMultiple: false,
  isWhite: false,
  options: [],
  totalColumn: 1,
  checkboxStyle: {},
  checkboxCheckedStyle: {},
  checkboxContainerStyle: {},
  isManualError: false,
  onChange: () => {},
  isManualContext: false,
};

const CheckBoxDefault = (props) => {
  const formikContext = props.isManualContext ? useFormikContext() : null;
  const dataFormik = formikContext
    ? useFormikContext()
    : {
        errors: {},
        touched: {},
        values: {},
      };

  const {
    testID = 'checkbox',
    value = [],
    checked = false,
    disabled = false,
    isMultiple = false,
    options = [],
    labelKey = '',
    totalColumn = 1,
    checkboxStyle = {},
    checkboxCheckedStyle = {},
    checkboxContainerStyle = {},
    isWhite = false,
    children = null,
    isManualError = false,
  } = props;

  const [checkedMulti, setCheckedMulti] = useState([]);

  const isListDayEmpty =
    labelKey === 'list_day' &&
    Array.isArray(dataFormik?.values?.[labelKey]) &&
    dataFormik?.values?.[labelKey].length === 0;
  const manualError =
    isManualError &&
    dataFormik?.errors?.[labelKey] &&
    dataFormik?.touched?.[labelKey] &&
    (!dataFormik?.values?.[labelKey]?.length || isListDayEmpty)
      ? dataFormik?.errors?.[labelKey]
      : false;

  const onCheckmarkPress = () => {
    try {
      if (!disabled) {
        props.onChange(value);
      }
    } catch (error) {}
  };

  const onCheckmark = (val) => {
    if (isMultiple) {
      if (isManualError) {
        let newChecked = [...checkedMulti];

        if (val.value === 'anytime') {
          if (checkValue(val)) {
            newChecked = [];
          } else {
            newChecked = [...options];
          }
        } else {
          const index = newChecked.findIndex((x) => x.value === val.value);
          if (index > -1) {
            newChecked.splice(index, 1);
          } else {
            newChecked.push(val);
          }

          const allCheckedExceptAnytime = options
            .filter((x) => x.value !== 'anytime')
            .every((opt) => newChecked.some((x) => x.value === opt.value));

          if (allCheckedExceptAnytime) {
            newChecked.push({ value: 'anytime', [labelKey]: 'Anytime' });
          } else {
            newChecked = newChecked.filter((x) => x.value !== 'anytime');
          }
        }

        setCheckedMulti(newChecked);
        props.onChange(newChecked);
      } else {
        const index = checkedMulti.findIndex((x) => x.value === val.value);
        const newChecked = [...checkedMulti];
        if (index > -1) {
          newChecked.splice(index, 1);
        } else {
          newChecked.push(val);
        }
        setCheckedMulti(newChecked);
        // eslint-disable-next-line react/prop-types
        props.onChange(newChecked);
      }
    } else {
      // Handling Single Selection Case
      setCheckedMulti([val]);
      props.onChange(val);
    }
  };

  const checkValue = (val) => {
    if (isMultiple) {
      return checkedMulti.some((x) => x.value === val.value);
    } else {
      return checkedMulti.length > 0 && checkedMulti[0].value === val.value;
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMultiple && isMounted) {
      if (value?.length) {
        setCheckedMulti(value);
      } else {
        if (props.isManualContext && formikContext) {
          setCheckedMulti(dataFormik?.values?.[labelKey]);
        }
      }
    }
    return () => {
      isMounted = false;
    };
  }, [props]);

  return (
    <>
      {options?.length ? (
        <View
          testID={testID}
          style={[
            { flex: 1 },
            totalColumn > 1
              ? {
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  alignItems: 'flex-start',
                }
              : {},
          ]}>
          {options.map((opt, index) => {
            return (
              <TouchableOpacity
                testID={`${testID}-option-${index}`}
                key={'chk-box-' + index}
                style={[
                  styles.checkboxContainer,
                  {
                    marginBottom: 10,
                    width: 100 / totalColumn + '%',
                    marginRight: 0,
                    paddingRight: 10,
                  },
                  checkboxContainerStyle || {},
                ]}
                onPress={() => onCheckmark(opt)}>
                <View
                  style={[
                    styles.checkboxBase,
                    checkValue(opt) && styles.checkboxChecked,
                    checkboxStyle || {},
                    checkboxCheckedStyle || {},
                  ]}>
                  {checkValue(opt) ? (
                    <Ionicons
                      name="checkmark"
                      size={16}
                      color={isWhite ? Colors.blue0 : Colors.white}
                    />
                  ) : null}
                </View>
                <SociollaText>{opt[labelKey]}</SociollaText>
              </TouchableOpacity>
            );
          })}
          <FormError
            {...{ ...props, hasError: manualError ? manualError : false }}
          />
        </View>
      ) : (
        <TouchableOpacity
          testID={testID}
          style={[styles.checkboxContainer, checkboxContainerStyle || {}]}
          onPress={onCheckmarkPress}>
          <View
            style={[
              styles.checkboxBase,
              checked && styles.checkboxChecked,
              checkboxStyle || {},
              checkboxCheckedStyle || {},
            ]}>
            {checked && (
              <Ionicons
                name="checkmark"
                size={16}
                color={isWhite ? Colors.blue0 : Colors.white}
              />
            )}
          </View>
          {children}
        </TouchableOpacity>
      )}
    </>
  );
};

CheckBoxDefault.propTypes = propTypes;
CheckBoxDefault.defaultProps = defaultProps;

const styles = StyleSheet.create({
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 10,
  },
  checkboxBase: {
    width: 20,
    height: 20,
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 2,
    borderWidth: 2,
    borderColor: Colors.blue0,
    backgroundColor: 'transparent',
    marginBottom: 10,
  },
  checkboxChecked: {
    backgroundColor: Colors.blue0,
  },
});

export default React.memo(CheckBoxDefault, (prev, next) => prev == next);
